import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import * as styles from "./main.module.css"
import { api_base_url, browserstring } from "../../utils/auth"
import tippy from 'tippy.js';
import 'tippy.js/themes/light-border.css';
import './tippy.css';
const axios = require('axios').default;

const DonationForm = ({ amount, recipient, source, sender, cookie, postAction, enabled=true}) => {
  const [a, setAmount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setAmount(Number(amount))
  }, [amount]);

  const submitDonation = (e) => {
    setIsSubmitting(true)
    setTimeout(() => {
      axios({
        method: 'post',
        url: `${api_base_url()}/donation`,
        data: {
          CookieID: cookie,
          BrowserData: browserstring(),
          recipient_account_id: recipient,
          amount: a,
          source_reference: source
        }
      }).then(function(response) {
        if (response.status === 200) {
          setIsSubmitting(false)
          postAction(0)
         } else {
          setIsSubmitting(false)
          postAction(0, "Donationen misslyckades. Inga pengar har dragits från ditt konto.");
        }

      })
        .catch(function (error) {
          if (error.response.status === 402) {
            setIsSubmitting(false);
            postAction(a);
          } else {
            postAction(0, "Donationen misslyckades. Inga pengar har dragits från ditt konto.");
            setIsSubmitting(false)
          }
        });
    }, 400);
  }

  if (document.getElementById('donatebtn')) {
    tippy(document.getElementById('donatebtn'));
  }
  if (document.getElementById('submitbtn')) {
    tippy(document.getElementById('submitbtn'));
  }
  return(

    <div>
      <p className="px-5">
        Bekräfta donationen {(source.length > 0 && source !== "Not provided") ? (<span>till <span className={styles.boldinfo}>{source}</span></span> ) : null} genom
         att klicka på den gröna donationsknappen med beloppet. Ändra med de gula knapparna.
      </p>
      <div className="m-0 mb-3">
            <div className={styles.buttonContainer}>
            <button className={[styles.b_r_low, styles.controlbutton].join(" ")} value="1" onClick={(e) => setAmount(a + Number(e.target.value))}>+1 kr
            </button>
                <button className={[styles.b_r_mid, styles.controlbutton].join(" ")} value="5" onClick={(e) => setAmount(a + Number(e.target.value))}>+5 kr
            </button>
                <button className={[styles.b_r_high, styles.controlbutton].join(" ")} value="10" onClick={(e) => setAmount(a + Number(e.target.value))}>+10 kr
            </button>


        <div className={[styles.sumContainer, styles.controlbutton].join(" ")}>
          <button data-tippy-theme="light-border" data-tippy-content="Klicka här för att donera" id="submitbtn" className={styles.b_r_donate} disabled={isSubmitting  || a < 1 || !enabled} value={a} onClick={submitDonation}>
            {isSubmitting ? (
            <div className="spinner-border" role="status">
            </div>) :
              (
                <div className={"text-left"}>
                  <div className={styles.buttonconfirmtext}>Bekräfta</div>
                  <div>Belopp: {a} kr</div>
                </div>
              )}

          </button>
        </div>

            <button className={[styles.b_r_reset, styles.controlbutton].join(" ")} onClick={(e) => setAmount(0)}>C
            </button>
        </div>
      </div>

    </div>
  )
}

DonationForm.propTypes = {
  amount: PropTypes.string,
  recipient: PropTypes.string,
  sender: PropTypes.string,
  cookie: PropTypes.string,
  postAction: PropTypes.func,
}

DonationForm.defaultProps = {
  amount: ``,
  recipient: ``,
  sender: ``,
  cookie: ``,
}

export default DonationForm